// Re-export all API types from the service layer
export type {
  RecipeV2,
  RecipeV2Detail,
  RecipeV2ListResponse,
  RecipeComponent,
  RecipeAllergenSummary,
  AllergenTraceEntry,
  Allergen,
  ProductAllergen,
  CarbonFactor,
  ProductionMethod,
  RecipeVersion,
  AIFinding,
  CostBreakdownEntry,
  CostSimulationResult,
  DietaryAttribute,
  SupplierPrice,
  ComponentSupplierComparison,
  CreateRecipeRequest,
  CreateComponentRequest,
  ApproveRejectRequest,
  AllergenOverride,
  StockItemSearchResult,
  Equipment,
  RecipeStep,
  CreateUpdateStepRequest,
  UpdateComponentRequest,
  UpdateRecipeMetadataRequest,
  DietaryAttributeOverride,
  ConvertToStockRequest,
  ConvertToStockResult,
} from '../../app/services/api/recipeV2/recipeV2Types';

export type { RecipeDataCompleteness } from '../../app/services/api/recipeV2/recipeV2Types';

export {
  RecipeStatus,
  AllergenStatus,
  AllergenSource,
  ApprovalStatus,
  AIFindingSeverity,
  AIFindingStatus,
  CarbonRating,
  DietaryCategory,
  DietaryAttributeStatus,
  RecipeKind,
} from '../../app/services/api/recipeV2/recipeV2Types';

// UI-only types
export enum RecipeV2Tab {
  Ingredients = 'ingredients',
  Method = 'method',
  Costing = 'costing',
  /** Combined Allergens + Dietary tab (merged per Range Planning demo spec) - renders
   * AllergensTab and DietaryTab content together in one place. */
  AllergensDietary = 'allergens-dietary',
  Carbon = 'carbon',
  Versions = 'versions',
  AIInsights = 'ai-insights',
  /** Demo Mode only - commercial planning (demand/labour/forecast P&L) + trial tracking.
   * No backend persistence exists yet, see src/mocks/data/productPlanningData.ts. */
  Trial = 'trial',
  /** Demo Mode only - recipe-derived nutritional info, shares the NutritionalDataTab
   * component + types with Procurement Products (supplier-provided nutrition).
   * No backend persistence exists yet, see src/components/shared/nutrition. */
  Nutrition = 'nutrition',
  /** Demo Mode only - rule-based recipe QA/process checklist (yield, loss %, method and
   * allergen data completeness). Distinct from AIInsights, which surfaces AI findings. */
  ProcessChecks = 'process-checks',
  /** Demo Mode only - where this recipe is used (Menus referencing it). No backend
   * persistence exists yet, see src/mocks/data/recipeUsageData.ts. */
  Usage = 'usage',
}
